import React from 'react';
import { Camera, Trash2 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { ProfileAvatar } from './ProfileAvatar';

export const AvatarActionControls = ({ user, disabled, busy, onAction }) => {
  const hasPicture = !!user.avatar_id;
  const prompt = hasPicture ? 'Remove profile picture' : 'Add profile picture';
  return <TooltipProvider delayDuration={160}>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className="avatar-edit-current" data-testid="avatar-choose" disabled={disabled} aria-busy={busy} aria-label={prompt} onClick={onAction}>
          <ProfileAvatar avatarId={user.avatar_id} name={user.username} size={96} testid="avatar-editor-current" />
          <span className="avatar-edit-overlay" data-testid={hasPicture ? 'avatar-remove-overlay' : 'avatar-add-overlay'} aria-hidden="true">{hasPicture ? <Trash2 size={26} /> : <Camera size={26} />}</span>
        </button>
      </TooltipTrigger>
      <TooltipContent className="avatar-action-tooltip" side="top" data-testid="avatar-image-action-tooltip">{prompt}</TooltipContent>
    </Tooltip>
    <Tooltip>
      <TooltipTrigger asChild>
        <button type="button" className="account-avatar-edit-label" data-testid="account-avatar-edit-label" disabled={disabled} aria-label={prompt} onClick={onAction}><Camera size={13} aria-hidden="true" />Profile picture</button>
      </TooltipTrigger>
      <TooltipContent className="avatar-action-tooltip" side="bottom" data-testid="avatar-label-action-tooltip">{prompt}</TooltipContent>
    </Tooltip>
  </TooltipProvider>;
};